import { useState } from "react";
import primaryComponents from "../../../primaryComponents";
import { useOtpAuthTrigger } from "../../../../hooks/useOtpAuthTrigger";
import secondaryComponents from "../..";
import { ToolBtn } from "../ToolBtn";
import { useDispatch, useSelector } from "react-redux";
import { addDelivery } from "../../../../store/modules/checkoutInfo";

const DeliveryFee = ({
  currency_symbol,
  storeId,
  params = {},
  btnStyle = {},
}) => {
  const dispatch = useDispatch();
  const { delivery_fee } = useSelector(
    (state) => state?.checkoutReducer?.order_price_mod,
  );
  const [isActive, setIsActive] = useState(false);
  const [deliveryVal, setDeliveryVal] = useState(delivery_fee?.amount || "");
  const { handleOrderModuleAuth, isLoadingAuthAction } = useOtpAuthTrigger({
    storeId,
    params,
  });
  const closeModal = () => {
    setIsActive(false);
  };

  return (
    <>
      <ToolBtn
        text="Delivery"
        color="#7647EE"
        bgColor="#F2EDFE"
        style={btnStyle}
        onClick={() => {
          setIsActive(true);
        }}
      />
      <secondaryComponents.Modal
        isActive={isActive}
        closeModal={closeModal}
        width={500}
      >
        <div
          className="p-3"
          style={{ display: "flex", flexDirection: "column", gap: "25px" }}
        >
          <h4>Apply Delivery</h4>

          <div
            style={{
              border: "1px solid #ddd",
              padding: "8px",
              borderRadius: "4px",
            }}
          >
            <primaryComponents.InputField
              label={"Amount"}
              classNames="white"
              placeholder={`Enter delivery fee e.g. ${currency_symbol}1000`}
              isRequired={false}
              value={deliveryVal}
              type="number"
              min="0"
              name="deliveryFee"
              floatError={false}
              onChange={({ target: { value } }) => {
                setDeliveryVal(value);
              }}
            />
          </div>

          <primaryComponents.Button
            classNames={"btn btn--primary cover"}
            onClick={() => {
              handleOrderModuleAuth({
                actionKey: "add_delivery_fee_to_order",
                onSuccessCallBack: () => {
                  const floatValue =
                    deliveryVal === "" ? deliveryVal : Number(deliveryVal);

                  dispatch(addDelivery({ amount: floatValue }));
                  closeModal();
                },
              });
            }}
            isLoading={isLoadingAuthAction}
            isDisabled={isLoadingAuthAction}
          >
            Apply
          </primaryComponents.Button>
        </div>
      </secondaryComponents.Modal>
    </>
  );
};
export default DeliveryFee;
